/**
 * An invite link as a QR code, for a friend in the same room to scan with their phone's camera. It
 * holds the whole link, secret included, so the camera opens straight into the room. The e2e test
 * renders the same settings to check what's on screen.
 */
export const INVITE_QR = { ecc: "M", border: 2 } as const;
